export const Z_INDEX = {
  INPUT: 2,
  SET_NEW_PASSWORD_INPUT: 2,
  TABLE_CONTAINER: 2,
};
